<template>
  <!-- <hello-world /> -->
  <release-notes/>
</template>

<script lang="ts">
import Vue from 'vue'
import ReleaseNotes from '../components/ReleaseNotes.vue'

export default Vue.extend({
  name: 'Home',

  components: {
    ReleaseNotes,
  },
})
</script>
